import { FC, useContext } from 'react';
import { ReviewPageContext } from '.';
import { Container } from './components';

const Late: FC = () => {
  const { interview } = useContext(ReviewPageContext);
  return (
    <Container>
      <p>
        {interview?.menteeLate
          ? "Vous ne vous êtes pas présenté(e) à l'heure du rendez-vous."
          : interview?.mentorLate
          ? "Votre mentor ne s'est pas présenté à l'heure du rendez-vous."
          : "Au moins un participant ne s'est pas présenté à l'heure du rendez-vous."}
      </p>
    </Container>
  );
};

export default Late;
